import { useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";

import { createUUID } from "../../utils/utils";
import "./enumeration-field.scss";
import { IEnumerationOption } from "../../definitions/datatypes";
import AuthContext from "../../../shared/context/auth-context";
import { roleRead } from "../../../shared/constants/user-roles";

export interface IEnumerationFieldConfig {
  label: string | undefined;
  autoFocus: boolean;
  required: boolean;
  inputKey: string;
  noEmptyDefault?: boolean;
  mode?: string;
  id?: string;
  extraId?: string;
  generateUniqueId?: boolean;
  handleOnChange(newValue: string | boolean | null, key?: string, id?:string, extraId?: string, parentId?: string): void
  defaultValue?: string | boolean | null;
  data: IEnumerationOption[];
  type?: string;
  parentId?: string;
  disabled?: boolean;
  extraClass?: string;
}

const EnumerationField = ({ data, label, extraClass, parentId, generateUniqueId, noEmptyDefault, id, autoFocus, extraId, required, type, disabled, handleOnChange, mode, inputKey, defaultValue }: IEnumerationFieldConfig) => {
  const [selected, setSelected] = useState<string>();
  const [readOnlyState, setReadOnlyState] = useState(false);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.length <= 1 && rolesArray.indexOf(roleRead) !== -1){
      setReadOnlyState(true);
    } else {
      setReadOnlyState(false);
    }
  }, [authCtx.selectedTenant.roles]);
  
  useEffect(() => {
    if (noEmptyDefault && data) {
      if (defaultValue === null || defaultValue === undefined || defaultValue === "") {
        if (data[0].id === "false" && data[1].id === "true") {
          //boolean
          handleOnChange(false, inputKey, id, extraId, parentId);
        } else {
          handleOnChange(data[0].id, inputKey, id, extraId, parentId);
        }
      }
    } else {
      if (defaultValue === null || defaultValue === undefined || defaultValue === "") {
        handleOnChange(null, inputKey, id, extraId, parentId);
      }
    }
  }, []);

  const filterOptions = () => {
    let result;
    if (inputKey === "label") {
      // filtering for the dataset situation
      switch (type) {
        case "text":
          result = data.filter((el) => el.id === "category" || el.id ==="amount_direction");
          break;
        case "enumeration":
          result = data.filter((el) => el.id === "category");
          break;
        case "integer":
          result = data.filter((el) => el.id === "category");
          break;
        case "reference":
          result = data.filter((el) => el.id === "entity");
          break;
        case "float":
          result = data.filter((el) => el.id ==="amount");
          break;
        case "datetime":
          result = data.filter((el) => el.id === "date" || el.id ==="time" || el.id ==="datetime");
          break;
        case "boolean":
          result = data.filter((el) => el.id === "suspicious" || el.id ==="alertcase" || el.id ==="amount_direction");
          break;
      }
    }
    return result;
  };
  
  useEffect(() => {
    if (defaultValue !== null && defaultValue !== undefined) {
      setSelected(defaultValue.toString());
    }
  }, [defaultValue]);

  const renderOptions = () => {
    let result = filterOptions();
    if (!result || result.length === 0) {
      result = [...data];
    }
    return result.map((option,index) => {
      return (
        <option key={index} value={option.id}>
          {option.name}
        </option>
      );
    });
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelected(event.target.value);
    if (event.target.value === "false") {
      handleOnChange(false, inputKey, id, extraId, parentId);
    }
    else if (event.target.value === "true") {
      handleOnChange(true, inputKey, id, extraId, parentId);
    }
    else if (event.target.value === null || event.target.value === undefined || event.target.value === "") {
      handleOnChange(null, inputKey, id, extraId, parentId);
    }
    else {
      handleOnChange(event.target.value, inputKey, id, extraId, parentId);
    }
  };

  return (
    <Form.Group className={`enumerationField ${extraClass}`} controlId={generateUniqueId? createUUID() : id}>
      <span className={mode === "aside" ? "enumerationField-aside-label" : ""}>
        {label? <Form.Label>{label}{required? " *" : ""}</Form.Label> : ""}
      </span>
      <Form.Select
        name={label}
        disabled={disabled || readOnlyState} 
        className={mode === "aside" ? "textInput-aside" : ""} 
        value={selected}
        onChange={onChangeHandler} 
        autoFocus={autoFocus}
        required={required}>

        {noEmptyDefault ? "" : <option value={""}></option>}
        {renderOptions()}

      </Form.Select>
      <Form.Control.Feedback type="invalid">
        {`Please provide the ${label}`}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default EnumerationField;
